import $ from "jquery";
import ContentBlock from "./ContentBlock";

let contentBlock: ContentBlock = new ContentBlock();
// @ts-ignore
window['contentBlock'] = contentBlock;

$(document).on('click', '[data-content-block-action]', function(e: JQuery.Event) {
    let action = $(this).attr('data-content-block-action');
    e.preventDefault();
    try {
        contentBlock.do(action);
    } catch (e) {}
});